import bankAccountScreens from './bank-account-screens.lang';
import addDebitCard from './add-debit-card.lang';
import cancelDebitCards from './cancel-debit-cards.lang';
import manageCrossover from './manage-crossover.lang';
import providerScreens from './provider-screens.lang';
import beneficiariesScreens from './beneficiaries-screens.lang';
import personalInformationScreens from './personal-information-screens.lang';
import profileInformationScreens from './profile-information-screens.lang';
import releaseAuthorizationScreens from './release-authorization-screens.lang';

export default {
  ...bankAccountScreens,
  ...addDebitCard,
  ...cancelDebitCards,
  ...manageCrossover,
  ...providerScreens,
  ...beneficiariesScreens,
  ...personalInformationScreens,
  ...profileInformationScreens,
  ...releaseAuthorizationScreens
};